import { UserQuery } from '@1bill-app/services/user/user.query';
import { UserService } from '@1bill-app/services/user/user.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavController, ToastController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { Clipboard } from '@capacitor/clipboard';

@Component({
  selector: 'app-email-bills',
  templateUrl: './email-bills.page.html',
  styleUrls: ['./email-bills.page.scss'],
})
export class EmailBillsPage implements OnInit {
  // billEmail: string;
  directEmail:any;
  public user$ = this.user.select('user');
  constructor(
    private router: Router, 
    private logger: NGXLogger,
    private route: ActivatedRoute,
    private navCtrl: NavController,
    private toastCtrl: ToastController,
    private user: UserQuery,
    private userSvc: UserService,
  ) { }

  ngOnInit() {
    // this.billEmail = this.route.snapshot.params.billEmail;
    // this.logger.debug('1bill email address: ' + this.billEmail);
    const { directEmail } = this.route.snapshot.queryParams;
    this.directEmail = directEmail;
    this.logger.log('directEmail', this.directEmail);
    this.userSvc.getUser().subscribe();
    
  }

  async copyToClipboard(value:string){
    await Clipboard.write({ string: value });
    const toast = await this.toastCtrl.create({
      message: 'Copied to clipboard',
      duration: 2000,
    });
    toast.present();
  }

  goBack() {
    this.navCtrl.back();
  }

}
